<template>
  <v-container>
    <v-card elevation="3" class="pa-6 rounded-lg citation-container" color="#f9f9f9">
      <!-- Citation Section -->
      <div class="mt-6">
        <h1 class="blue--text font-weight-bold text-h4 mb-4 gradient-text">Citation</h1>
        <v-divider class="my-4"></v-divider>
        <p class="text-body-1 mb-6">
          If you use our dataset, please cite our works:
        </p>

        <!-- Citation Cards -->
        <v-row>
          <v-col cols="12" md="12">
            <v-card 
              class="pa-4 rounded-lg citation-card" 
            >
              <!-- Citation Text -->
              <span ref="metadata" class="citation-text">
                <span style="color: rgb(195, 92, 7)">@articles</span>{<span style="color: rgb(7, 117, 195)">sinha2024marvel</span>, <br>
                title={MARVEL-40M+: Multi-Level Visual Elaboration for High-Fidelity Text-to-3D Content Creation},<br>
                author    = {Sinha, Sankalp and Khan, Mohammad Sadil and Usama, Muhammad and Sam, Shino and Stricker, Didier and Ali, Sk Aziz and Afzal, Muhammad Zeshan}, <br>
                journal={arXiv preprint arXiv:2411.17945}, <br>
                year      = {2024}, <br>
                } <br>
              </span>

              <!-- Copy Button -->
              <v-btn 
                :disabled="isCopied" 
                @click="copyText"
                color="primary"
                class="mt-4"
              >
                <v-icon left>{{ isCopied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
                {{ isCopied ? 'Copied!' : 'Copy to Clipboard' }}
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AcknowledgementAndCitation",

  data() {
    return {
      isCopied: false,
    };
  },

  methods: {
    copyText() {
      // 1) Access the text from the <code> element via a Vue ref
      const textToCopy = this.$refs.metadata.innerText;

      // 2) Use the Clipboard API to copy the text
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          // Update button state
          this.isCopied = true;

          // Revert back after 1.5 seconds
          setTimeout(() => {
            this.isCopied = false;
          }, 1500);
        })
        .catch((err) => {
          console.error("Error copying text:", err);
        });
    },
  },
};
</script>

<style scoped>

.citation-container {
  background: linear-gradient(135deg, #973deb07, #86ceeb10); /* Subtle gradient */
}

.citation-card {
  /* border: 1px solid; */
  /* transition: box-shadow 0.3s ease; */
  background-color: rgb(41, 37, 37, 0);
}

.citation-card:hover {
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
}

.citation-text {
  font-family: "Fira Code", monospace;
  /* white-space: pre-wrap; */
  /* background-color: #ffffff; */
  padding: 15px;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
}

.v-btn {
  font-weight: 600;
  text-transform: none;
}

.v-divider {
  background-color: #1976d2;
  height: 2px;
}

.gradient-text {
    font-weight: bold;
    font-size: 2rem; /* Adjust as needed */
    background: linear-gradient(to right, #007bff, #9168df, #b65c6c, #da9462);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}

</style>
